import { requestWithToken } from '../../utilities/request';
import SessionStorageService from '../../services/utilities/SessionStorageService';
const path = '/api/private/fields';

/**
 * 現場情報取得API
 * @param {string}fieldsId: 現場ID
 * */
const fetchFieldInfo = fieldsId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldsId}`),
  });
};

/**
 * 入退場者数取得API
 * @param {string}fieldsId: 現場ID
 * */
const fetchEnteredAndExitCount = fieldsId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldsId}/check_in_out_logs/entered_and_exit_count`),
  });
};

/**
 * CCUS送信履歴API
 * @param {string}fieldsId: 現場ID
 * @param {object}param
 * */
const fetchCheckInOutLogTransmissionHistories = (fieldsId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldsId}/check_in_out_log_transmission_histories`),
    params: param,
  });
};

/**
 * 未承認数取得API
 * @param {string}fieldsId: 現場ID
 * */
const fetchUnapprovedCount = fieldsId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldsId}/check_in_out_logs/unapproved_count`),
  });
};

/**
 * CCUS送信結果エラー情報取得API
 * @param {string}fieldsId: 現場ID
 * @param {object}param
 * */
const fetchErrorResults = (fieldsId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldsId}/check_in_out_log_transmission_results/error_results`
    ),
    params: param,
  });
};

/**
 * 顔画像登録数、入退場者数を取得API
 * @param {string}fieldsId: 現場ID
 * */
const fetchMonthlyCount = fieldsId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldsId}/face_api_field_worker_image_histories/summary`
    ),
  });
};

/**
 * 請求月取得API
 * @param {string}fieldsId: 現場ID
 * */
const fetchClosedBillingMonth = fieldsId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldsId}/face_api_field_worker_image_histories/closed_billing_month_lists`
    ),
  });
};

/**
 * 顔画像登録数・入退場者数EXCEL取得API
 * @param {string}fieldsId: 現場ID
 * @param {string}billingMonth: 請求月
 * @param {object}param
 * */
const fetchMonthlyCountExcel = (fieldsId, billingMonth) => {
  const token = SessionStorageService.getToken();
  const apiPath = path.concat(
    `/${fieldsId}/kaoreco_closed_field_billings/excel?excel_token=${token}`
  );
  const param = {
    billing_month: billingMonth,
  };
  return requestWithToken({
    method: 'GET',
    url: apiPath,
    params: param,
    responseType: 'blob',
  });
};

/**
 * @param {string}fieldId: 現場ID
 * */
const fetchMainJvSecededCcus = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/main_jv_ccus_seceded_warning`),
  });
};

export const InOutDashboardApi = {
  fetchFieldInfo,
  fetchEnteredAndExitCount,
  fetchCheckInOutLogTransmissionHistories,
  fetchUnapprovedCount,
  fetchErrorResults,
  fetchMonthlyCount,
  fetchMonthlyCountExcel,
  fetchClosedBillingMonth,
  fetchMainJvSecededCcus,
};

export default InOutDashboardApi;



// WEBPACK FOOTER //
// ./src/services/inOutDashboard/InOutDashboardApi.js